import {Injectable} from '@angular/core';
import {BaseService} from "../../../services/base.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {RootObject} from "../models/product";
import {User} from "../models/user";
import {environment} from "../../../environments/environment";
import {AuthService} from "../../../services/auth.service";

@Injectable({
    providedIn: 'root'
})
export class UserService extends BaseService {

    constructor(private httpClient: HttpClient, private authService: AuthService) {
        super();
    }

    // info: User;
    //
    //
    // addUserInfo(user: User) {
    //     this.info = user;
    // }
    //
    // getUserInfo() {
    //     return this.info;
    // }

    public getCustomerInfo() {

        let serviceURL = this.baseAPI + "V1/customers/me"
        return this.httpClient.get<any>(serviceURL, this.authService.getHttpOptions());

    }

    public passwordReset(email) {

        let serviceURL = this.baseAPI + "customers/password"

        let obj = {
            email: email,
            template:'email_reset',
            websiteId: 1
        }

        return this.httpClient.put<any>(serviceURL, obj,this.authService.getHttpOptions());

    }

    public signUp(customer: User) {


        return this.httpClient.post<any>(this.baseAPI + "customers", customer, this.authService.getHttpOptions());

    }

    public isEmailAvailable(): any {
        return this.httpClient.post<any>(this.baseAPI + ` + 'adham/customer/check'}`, {"email": "dua.intern@adham.ps"}, this.authService.getHttpOptions());

    }


}
